import { render, staticRenderFns } from "./OpenJobsStatistics.vue?vue&type=template&id=5d13e2ae&scoped=true&"
import script from "./OpenJobsStatistics.vue?vue&type=script&lang=js&"
export * from "./OpenJobsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./OpenJobsStatistics.vue?vue&type=style&index=0&id=5d13e2ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d13e2ae",
  null
  
)

export default component.exports